export default __webpack_public_path__ + "static/media/svg-2.2e8662f1.svg";